// src/App.js - FINAL ARCHITECTURALLY CORRECT VERSION

import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LinksMenu from './components/LinksMenu';
import MusicPlayer from './components/MusicPlayer';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

// --- HOTSPOT DATA (Unchanged) ---
const HOTSPOTS_DATA = [
  { id: 1, x: 3050, y: 1020, title: "NFT Door Lock", image: "/imageholders/foxdoorlock.jpg", imageEnabled: true, content: [{ type: 'p', text: 'Step into the future, literally. This robotic fox head with glowing camera eyes is more than decoration, it\'s a fully functional NFT-authenticated door lock.' },{ type: 'p', text: 'Just scan your wallet or QR code and gain access to our IRL café. It\'s a real-world use case of blockchain tech, turning NFTs into keys. This symbolizes our belief in real-life utility for digital identity and IRL blockchain authentication.' },{ type: 'p', text: 'We worked hard to build the first blockchain-verified door access system tied to NFTs, because NFTs should do more than pictures in wallets.' }]},
  { id: 2, x: 4080, y: 970, title: "Crypto Paper Wallet", image: "/imageholders/cryptopaperwallet.jpg", imageEnabled: true, content: [{ type: 'p', text: 'Right inside the café, visitors can generate physical paper wallets on demand. Each printout includes a QR code to crypto wallet address with its seed phrase, designed for education, onboarding, and gifting. This crypto printer connects new users with Web3, without even needing a phone or laptop.' },{ type: 'p', text: 'This is the Web3 version of printing money, only cuter.' }]},
  { id: 3, x: 4700, y: 1260, title: "Official New Foxes NFT Marketplace", content: [{ type: 'p', text: 'We created this marketplace as a home for our community. It’s the perfect place to connect, trade, and collect your favorite New Foxes.' },{ type: 'p', text: 'Discover rare finds, complete your collection, and join the conversation.' }], linkUrl: 'https://shop.newfoxes.com', linkText: 'Buy or List Your NFT' },
  { id: 4, x: 5200, y: 700, title: "Interactive NFT Wall Tablets", image: "/imageholders/nfttablets.jpg", imageEnabled: true, content: [{ type: 'p', text: 'This isn\'t just art. These digital NFT tablets are synced with our marketplace, allowing holders to list their NFTs for sale and showcase them inside our physical café.' },{ type: 'p', text: 'It\'s a real-life NFT gallery and marketplace where every visitor can browse, ask, and potentially buy. This is how NFTs should be sold: in person, on display, respected like art.' }], linkUrl: 'https://shop.newfoxes.com', linkText: 'List Your NFT' },
  { id: 5, x: 5844, y: 1185, title: "The $NOX Reward Cycle", content: [{ type: 'p', text: 'Introducing the Fortnight Claiming System: get free $NOX tokens every two weeks just for holding your New Fox NFT. No staking. No locking. Just proof of loyalty.' },{ type: 'list', items: [{ text: "OG Fox: 75 $NOX", emoji: 'og' },{ text: "Private Fox: 50 $NOX", emoji: 'private' },{ text: "Special Fox: 250 $NOX", emoji: 'special' }]},{ type: 'p', text: 'If you list or transfer, your timer resets. But you can claim retroactively anytime. It\'s our way of saying thank you for believing in the fox family.' }], linkUrl: 'https://nox.newfoxes.com', linkText: 'Claim $NOX | Swap | Liquidity' },
  { id: 6, x: 6977, y: 1167, title: "NFT Coffee Latte Machine", image: "/imageholders/nftlatte.jpg", imageEnabled: true, content: [{ type: 'p', text: 'Bring your NFT. Order a coffee. Watch it come to life in foam. That\'s right, we made the world\'s first NFT latte printer. Customers scan their wallets, and their unique NFT is printed in latte foam on their drink. It\'s delicious Web3 branding.' },{ type: 'p', text: 'This isn\'t just a gimmick, it\'s another chapter in our mission to merge Web3 with real life.' }]},
  { id: 7, x: 8414, y: 882, title: "FoxPay: Your Discord Crypto Wallet", content: [{ type: 'p', text: 'FoxBot is our flagship Discord bot, allowing instant $SOL and $NOX tips, payments, and rewards right inside servers.' },{ type: 'p', text: '💳 /create – Generate wallet\n💸 /send – Tip friends instantly\n📈 /balance, /swap – Track & trade\n🔥 AI trading features coming soon' },{ type: 'p', text: 'Perfect for creators, DAO leaders, traders, and community builders. Your Discord server becomes a real crypto wallet with FoxPay.' }], linkUrl: 'https://top.gg/bot/1212407364502953994', linkText: 'Invite FoxPay' },
  { id: 8, x: 9846, y: 1325, title: "Web3 Learning Hub: From Zero to Builder", content: [{ type: 'p', text: 'This is where students, traders, and builders meet. We\'ve created a safe space for newcomers to learn about NFTs, Solana, wallets, and beyond, all with the support of veteran foxes.' },{ type: 'p', text: '👨‍🏫 Education is at the heart of our movement. Many here made their first crypto purchase because of New Foxes.' }], linkUrl: 'https://discord.newfoxes.com', linkText: 'Join our Discord' },
  { id: 9, x: 12124, y: 1497, title: "Move-to-Earn: $NOX for Healthy Habits", content: [{ type: 'p', text: 'We were first to create a Discord-integrated health bot that rewards users with $NOX just for being active. Whether it\'s walking, running, or logging workouts, we care about mental health in Web3.' },{ type: 'p', text: '🧠 A healthier community is a smarter one.' }]},
  { id: 10, x: 13659, y: 957, title: "New Fox Plushie Collection", image: "/imageholders/foxplush.jpg", imageEnabled: true, content: [{ type: 'p', text: 'You\'ve seen them in art. Now you\'ll hold them in your hands. We\'re building high-quality plush toys based on our cute New Foxes NFTs to expand the New Foxes universe. Some may even come with secret codes for NFT claims or IRL discounts.' },{ type: 'p', text: '🧸 Collect, cuddle, connect.' }], linkUrl: '#', linkText: 'Coming Soon' },
  { id: 11, x: 15316, y: 1595, title: "Your Fox, Your Brand", content: [{ type: 'p', text: 'We are one of the few NFT projects to give our holders full IP rights over their New Fox NFTs. You can create your own merch, brand, or business, your NFT is your identity.' },{ type: 'p', text: 'This handshake zone represents collaboration, licensing, and creator empowerment. Your NFT is more than a PFP. It\'s your intellectual property.' }]}
];

// --- CONFIGURATION ---
const MASTER_TOTAL_WIDTH = 16384;
const MASTER_HEIGHT = 1900;
const MASTER_ASPECT_RATIO = MASTER_TOTAL_WIDTH / MASTER_HEIGHT;
const TILE_SETS = {
  sm: { name: 'sm', tileWidth: 800 }, md: { name: 'md', tileWidth: 1366 },
  lg: { name: 'lg', tileWidth: 1600 }, xl: { name: 'xl', tileWidth: 1920 },
};

// --- A. UTILITY & HOOKS ---
const useWindowSize = () => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  useLayoutEffect(() => {
    const updateSize = () => setSize([window.innerWidth, window.innerHeight]);
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

const getOptimalTileSet = (width) => {
  if (width <= 800) return TILE_SETS.sm;
  if (width <= 1366) return TILE_SETS.md;
  if (width <= 1600) return TILE_SETS.lg;
  return TILE_SETS.xl;
};

// --- B. REUSABLE COMPONENTS ---
const HotspotPopup = ({ hotspot, onClose }) => {
  if (!hotspot) return null;
  return (
    <div className="hotspot-popup-overlay" onClick={onClose}>
      <div className="hotspot-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="hotspot-popup-close" onClick={onClose}>×</button>
        {hotspot.imageEnabled && (<div className="hotspot-image-container"><img src={hotspot.image} alt={hotspot.title} /></div>)}
        <div className="hotspot-text-container">
          <h3>{hotspot.title}</h3>
          {hotspot.content.map((item, index) => {
            if (item.type === 'p') return <p key={index} style={{ whiteSpace: 'pre-wrap' }}>{item.text}</p>;
            if (item.type === 'list') return <ul key={index}>{item.items.map((li, liIndex) => <li key={liIndex} className={`emoji-${li.emoji}`}>{li.text}</li>)}</ul>;
            return null;
          })}
          {hotspot.linkUrl && <a href={hotspot.linkUrl} target="_blank" rel="noopener noreferrer" className="hotspot-cta-link">{hotspot.linkText}</a>}
        </div>
      </div>
    </div>
  );
};

const Hotspot = ({ hotspot, onHotspotClick, isActive }) => {
  const leftPercent = (hotspot.x / MASTER_TOTAL_WIDTH) * 100;
  const topPercent = (hotspot.y / MASTER_HEIGHT) * 100;
  return (<div className={`hotspot ${isActive ? 'active' : ''}`} style={{ left: `${leftPercent}%`, top: `${topPercent}%` }} onClick={() => onHotspotClick(hotspot)}><div className="hotspot-dot"></div></div>);
};

// --- C. THE EXPERIENCE COMPONENT (Unchanged) ---
const Experience = ({ width, height, tileSet, isMobile, activeHotspot, onHotspotClick }) => {
  const mainRef = useRef();
  const storyContainerRef = useRef();
  const numTiles = Math.ceil(MASTER_TOTAL_WIDTH / tileSet.tileWidth);

  useEffect(() => {
    const theoreticalWidth = height * MASTER_ASPECT_RATIO;
    const totalStoryWidth = Math.ceil(theoreticalWidth);
    const scrollDistance = totalStoryWidth - width;

    let ctx = gsap.context(() => {
      gsap.set(storyContainerRef.current, { width: totalStoryWidth });
      gsap.to(storyContainerRef.current, {
        x: -scrollDistance, ease: "none",
        scrollTrigger: {
          trigger: mainRef.current, pin: true,
          scrub: isMobile ? 1.2 : 1.5,
          end: `+=${scrollDistance}`,
        }
      });
    }, mainRef);

    return () => ctx.revert();
  }, [width, height, tileSet, isMobile]);
  
  return (
    <div ref={mainRef} className="experience-container">
      <div ref={storyContainerRef} className="story-container">
        {Array.from({ length: numTiles }).map((_, index) => (
          <img key={index} src={`/story-tiles-${tileSet.name}/tile-${index + 1}.webp`} alt="" className="story-tile" />
        ))}
        {HOTSPOTS_DATA.map(hotspot => 
          <Hotspot 
            key={hotspot.id} hotspot={hotspot} 
            onHotspotClick={onHotspotClick}
            isActive={activeHotspot?.id === hotspot.id} 
          />
        )}
      </div>
    </div>
  );
};


// --- D. MAIN APP (Manages player visibility state) ---
function App() {
  const [width, height] = useWindowSize();
  const [activeHotspot, setActiveHotspot] = useState(null);
  const [isPlayerVisible, setPlayerVisible] = useState(true); // Default to show true
  
  const mobileBreakpoint = 900;
  const tileSet = getOptimalTileSet(width);
  const isMobile = width <= mobileBreakpoint;

  return (
    <>
      <LinksMenu 
        isPlayerVisible={isPlayerVisible}
        onTogglePlayer={setPlayerVisible}
      />
      <Experience 
        key={isMobile ? 'mobile' : 'desktop'} 
        width={width} 
        height={height} 
        tileSet={tileSet}
        isMobile={isMobile}
        activeHotspot={activeHotspot}
        onHotspotClick={setActiveHotspot}
      />
      <HotspotPopup 
        hotspot={activeHotspot} 
        onClose={() => setActiveHotspot(null)}
      />
      <MusicPlayer isVisible={isPlayerVisible} />
    </>
  );
}

export default App;